import { HttpHeaders } from '@angular/common/http';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, forkJoin, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { SweetAlertService } from 'src/services/sweetAlertService';

@Component({
  selector: 'app-my-requests',
  templateUrl: './my-requests.component.html',
  styleUrls: ['./my-requests.component.css']
})
export class MyRequestsComponent {

  currentServices: any[] = [];
  archiveService: any[] = [];
  userId:string=this.authService.getNationalNumber()!;
  isLoading: boolean = true;
  mainPath = "" // قراءة القيمة من environment
  SectionIdEnv = ""
  
  oldArchiveService: any[] = [];
  oldCurrentServices: any[] = [];

  constructor(private apiService:ApiService,private route: ActivatedRoute,
    private sweetAlertService:SweetAlertService,private authService:AuthService
    ) {
      this.mainPath= environment.MainPath;
      this.SectionIdEnv= environment.SectionId;

      forkJoin([this.fillCurrentServicesForConsumer(),this.fillArchiveServicesForConsumer()])
      .pipe(finalize(() => this.isLoading = false))
      .subscribe();

      setTimeout(() => {
      
        const tabs = document.querySelectorAll('[data-role="tab"]'),
      tabContents = document.querySelectorAll(".tab-panel");
      
      tabs.forEach((tab:any) => {
        tab.addEventListener("click", () => {
          const target = document.querySelector(tab?.dataset?.target);
      
          tabContents.forEach((tc) => {
            tc.classList.remove("is-active");
          });
          target.classList.add("is-active");
      
          tabs.forEach((t) => {
            t.classList.remove("is-active");
          });
          tab.classList.add("is-active");
        });
      });
  
      }, 2000);

      this.fillOldRequest();

    
  }

  fillCurrentServicesForConsumer() {


    var link="carboncopies/GetCurrentServicesForConsumer?SortOrder=desc";

    if(environment.production){
      link+="&EntityId="+this.SectionIdEnv;
    }

    return this.apiService.get(link)
      .pipe(
        tap(response => {
          if(response.statusCode == 200) {
          var requests = response.data as any[];
          var data = requests as any;
          this.currentServices = data.items;
        }
        }),
      );
  }

  fillArchiveServicesForConsumer() {

    var link="carboncopies/GetArchivedServicesForConsumer?SortOrder=desc";

    if(environment.production){
      link+="&EntityId="+this.SectionIdEnv;
    }

    return this.apiService.get(link)
      .pipe(
        tap(response => {
          if(response.statusCode == 200) {
          var requests = response.data as any[];
          var data = requests as any;
          this.archiveService = data.items;
        }
        }),
      );
  }

  fillOldRequest(){

    var oldRequests = this.apiService.get(`moin/GetOldRequest`,environment.govnet);
    
    oldRequests.subscribe(response=>{

      var items=response.data;

      var resp=items as any[];

      this.oldArchiveService=resp.filter(x=>x.status==0 ||x.status==9);

      this.oldCurrentServices=resp.filter(x=>x.status!=0 && x.status!=9);

    });
  }

  showRejectedType(id:string){
    var archiveService=this.archiveService.filter(x=>x.id==id)[0];

    this.sweetAlertService.ShowAlert('info',archiveService.rejectReason??"");
  }

  openOldApplicant(id:string){
    window.open(`${environment.oldWebsite}/ar/portal/in?token=${this.authService.getToken()}&model=requests&id=${id}`);
}

}
